import { render, staticRenderFns } from "./CommentsTab.vue?vue&type=template&id=d287030c&scoped=true&"
import script from "./CommentsTab.vue?vue&type=script&lang=js&"
export * from "./CommentsTab.vue?vue&type=script&lang=js&"
import style0 from "./CommentsTab.vue?vue&type=style&index=0&id=d287030c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d287030c",
  null
  
)

component.options.__file = "CommentsTab.vue"
export default component.exports